/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import APICallService from '../../../../api/apiCallService'
import { AUTH } from '../../../../api/apiEndPoints'
import { AuthJSON } from '../../../../api/apiJSON/auth'
import { auth } from '../../../../utils/toast'
import LoginBg from '../../../../_supplier/assets/media/login bg.png'
import BackArrow from '../../../../_supplier/assets/media/svg_supplier/back arrow.svg'
import { authCardClassName } from '../AuthLayout'


const loginSchema = Yup.object().shape({
  email: Yup.string().required('Email / Phone is required'),
})

const initialValues = {
  email: '',
}

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [phoneCountry, setPhoneCountry] = useState('')
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        let data = {}
        if (/^\d+$/.test(values.email)) {
          data = { phone: values.email, phoneCountry: '+255' }
          setPhoneCountry('+255')
          setPhone(values.email)
        } else {
          data = { email: values.email }
          setPhone(values.email)
        }

        let apiService = new APICallService(
          AUTH.FORGOTPASSWORD,

          AuthJSON.forgotPassword(data)
        )
        let response = await apiService.callAPI()
        if (response) {
          toast.success(auth.resendOTP)
          navigate('/auth/verify-password', { state: data })
        }
      } catch (error) {
        setStatus('The login details are incorrect')
      }
      setSubmitting(false)
      setLoading(false)
    },
  })

  const isEmailEmpty = !formik.values.email.trim()

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid min-vh-100 h-100'>
      <div
        className='d-flex flex-column flex-lg-row-fluid w-lg-50 bg-body px-4 py-6 sm:px-6 sm:py-8 lg:p-25 order-2 overflow-auto min-h-0'
        style={{
          backgroundImage: `url(${LoginBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          
        }}
      >
        <div className='d-flex w-100 justify-content-center justify-content-lg-end align-items-center flex-lg-row-fluid py-2 sm:py-4 lg:py-0' style={{paddingRight: '86px'}}>
          <form
            className={clsx(authCardClassName, 'd-flex flex-column')}
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <div className='mb-4 sm:mb-6 flex-grow-1'>
              <div
                className='mb-3 mx-auto'
                style={{
                  display: 'flex',
                  width: '72px',
                  height: '72px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '9px',
                  borderRadius: '99px',
                  background: 'var(--white, #FFF)',
                }}
              >
                <span role='img' aria-label='lock' className='text-[34px]'>
                  🔒
                </span>
              </div>
              <h1 className='text-dark text-center fw-700 mb-3 text-[22px] sm:text-[26px] lg:text-[28px] gap-6'>
                Forgot Your Password?
              </h1>
              <p className='text-[#1A1A1A] text-center fw-500 mb-3 text-[22px] sm:text-[26px] lg:text-[16px] gap-6' style={{ width: '356px', margin: '0 auto' }}>
                Please enter your registered email address or phone number to receive an OTP for
                resetting your password.
              </p>
              <div className='flex flex-col items-center w-full mx-auto mb-4 sm:mb-5 mt-4 sm:mt-5 gap-6'>
                <input
                  placeholder='Email or mobile phone number'
                  {...formik.getFieldProps('email')}
                  className={clsx('form-control form-control-custom text-center border-0')}
                  style={{
                    display: 'flex',
                    width: '416px',
                    height: '56px',
                    padding: '10px 20px',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                  type='text'
                  name='email'
                  value={formik.values.email.trimStart()}
                  onChange={(e) => {
                    formik.handleChange(e)
                  }}
                  autoComplete='off'
                />

                <button
                  type='submit'
                  id='kt_sign_in_submit'
                  className={clsx('form-control form-control-custom text-center border-0')}
                  style={{
                    display: 'flex',
                    width: '416px',
                    height: '56px',
                    padding: '10px 20px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px',
                    background: '#1B74E4',
                    borderRadius: '12px',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#fff',
                    opacity: isEmailEmpty || loading ? 0.5 : 1,
                    cursor: isEmailEmpty || loading ? 'not-allowed' : 'pointer',
                  }}
                  disabled={isEmailEmpty || loading}
                >
                  {!loading && <span className='indicator-label fs-16 fw-bolder'>Continue</span>}
                  {loading && (
                    <span className='indicator-progress indicator-label fs-16 fw-600'>
                      Please wait...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>

            <div className='d-flex justify-content-center' style={{ padding: '40px' }}>
              <Link
                to='/auth/login'
                className='text-[#1B74E4] font-bold text-sm sm:text-[16px]'
                style={{
                  display: 'flex',
                  width: '416px',
                  height: '56px',
                  padding: '16px 22px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  borderRadius: '12px',
                  border: '1px solid var(--brand-primary-blue, #1B74E4)',
                  background: 'var(--white, #FFF)',
                }}
              >
                <img src={BackArrow} alt='' width={18} height={18} />
                Back to Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
export { ForgotPassword }
